module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./LogisticsListView.js"));
	}, "LogisticsListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LogisticsListView!./src/pages/Shop/Member/TradeManage/OrderList/LogisticsList/LogisticsListView.js
// module id = 1045
// module chunks = 431